module.exports = __webpack_public_path__ + "img/hatchet-stone.788b2a27.svg";